import {Component, inject, PLATFORM_ID} from '@angular/core';
import {GoogleAnalyticsService} from '../../../shared/analytics/google/google-analytics.service';
import {NgxShinyTextComponent} from '@omnedia/ngx-shiny-text';
import {Button} from 'primeng/button';
import {NavigatorDirective} from '../../../shared/directive/navigator.directive';
import {formComponentSignal} from '../../../shared/signal/common/form-component.signal';
import {isPlatformBrowser} from '@angular/common';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../../shared/enum/gtm-cookie-consent.enum';
import {Theme} from '../../../shared/enum/theme.enum';
import {PixelService} from '../../../shared/analytics/meta/pixel.service';
import {PixelEventName} from '../../../shared/analytics/meta/types/pixel.types';

@Component({
  selector: 'app-auctions-hero',
  imports: [
    NgxShinyTextComponent,
    Button,
    NavigatorDirective
  ],
  templateUrl: './auctions-hero.component.html',
  styleUrl: './auctions-hero.component.scss'
})
export class AuctionsHeroComponent {

  private readonly analyticsService: GoogleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly isBrowser: boolean = isPlatformBrowser(this.platformId);
  protected readonly auctionsFormComponentSignal = formComponentSignal;

  constructor(private readonly pixelService: PixelService) {
  }

  protected onCtaClick(): void {
    this.analyticsService.trackEvent({
      event: AnalyticsEventName.RequestCtaClick,
      eventCategory: AnalyticsEventCategory.CTA,
      eventPayload: Theme.AUCTIONS
    });

    this.pixelService.trackEvent(
      PixelEventName.RequestCta, {
        page: Theme.AUCTIONS
      });
  }
}
